<script setup lang="ts">
// "Честно. Даже когда непросто." — a big patch of rust linen with the belly-up cat
// (a whole cut-out) lying along its bottom edge; the CTA is a cream stock button.
import { RouterLink } from 'vue-router';
import { Button } from '@/components/ui/button';
import ScrollReveal from '@/components/ui/animation/ScrollReveal.vue';
import PaperCutout from '@app/presentation/components/paper/PaperCutout.vue';
import { APP_CTA_TO, TELEGRAM_BOT_URL } from '@app/presentation/components/site/constants';
</script>

<template>
  <section class="py-16 md:py-24">
    <div class="site-container">
      <ScrollReveal>
        <!-- [background-size:auto]: .paper-sheet sizes its layers to the 512px grain tile, so on a
             sheet wider than that the fabric would repeat with a visible seam. -->
        <div class="paper-sheet fabric-linen relative overflow-hidden bg-stock-rust [background-size:auto] p-8 pb-40 text-foreground sm:pb-44 md:p-14 md:pb-14">
          <div
            class="pointer-events-none absolute bottom-3 right-3 z-[1] w-[230px] md:right-8 md:w-[330px]"
            aria-hidden="true"
          >
            <PaperCutout
              name="belly_cat"
              lazy
            />
          </div>
          <div class="relative z-[1] max-w-[560px]">
            <h2 class="type-display">Честно. Даже когда непросто.</h2>
            <p class="mt-[18px] text-[17px] leading-relaxed sm:text-lg">
              Кот не кормит ложными надеждами. Иногда карта — это «отпусти». Но он всегда скажет это бережно и оставит выбор за тобой.
            </p>
            <div class="mt-7 flex flex-wrap items-center gap-x-5 gap-y-3">
              <Button
                as-child
                size="lg"
                variant="secondary"
              >
                <RouterLink :to="APP_CTA_TO">Задать свой вопрос</RouterLink>
              </Button>
              <a
                :href="TELEGRAM_BOT_URL"
                target="_blank"
                rel="noopener"
                class="text-sm underline underline-offset-4 opacity-90 hover:opacity-100"
              >или в Telegram</a>
            </div>
          </div>
        </div>
      </ScrollReveal>
    </div>
  </section>
</template>
